import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

@Injectable()
export class JobSiteRestrictedFeature implements IFlagFeature {
  name = Features.JOBSITE_RESTRICTED;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
